import { render, staticRenderFns } from "./publicAddress.vue?vue&type=template&id=0725d39a&scoped=true"
import script from "./publicAddress.vue?vue&type=script&lang=js"
export * from "./publicAddress.vue?vue&type=script&lang=js"
import style0 from "./publicAddress.vue?vue&type=style&index=0&id=0725d39a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0725d39a",
  null
  
)

export default component.exports